import React from 'react';

// "Kalah in Action" — three real photos that bring teaching credibility to the
// Learn-to-Teach section.  Some original slide photos carry third-party
// organisation logos at the bottom of the projected slide — those areas are
// covered by a small backdrop-blur overlay positioned over the offending region.

const photos = [
  {
    id: 'halloween-class',
    src: 'https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/6kkl23mm_image.png',
    alt: 'Kalah leading an engaging themed online class for young learners',
    caption: 'Engaging online classes that children love',
    objectPosition: 'center',
    // No logo in this photo.
    blurZones: []
  },
  {
    id: 'phonics-keynote',
    src: 'https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/fm3ut5q2_Screenshot%202026-06-20%20085536.jpg',
    alt: 'Kalah delivering a keynote on Phonics & Phonemic Awareness to fellow educators',
    caption: 'Keynote: Phonics & Phonemic Awareness',
    objectPosition: 'center',
    blurZones: []
  },
  {
    id: 'sounds-of-letters',
    src: 'https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/ve3vjsog_teachteachers.jpg',
    alt: 'Kalah training teachers on the Sounds of Letters',
    caption: 'Training teachers on the Sounds of Letters',
    objectPosition: 'center',
    blurZones: []
  }
];

const KalahInAction = () => {
  return (
    <section
      id="kalah-in-action"
      data-testid="kalah-in-action"
      className="py-16 px-4 sm:px-6 lg:px-8 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <div className="inline-block bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Kalah in Action
          </div>
          <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Real classrooms. Real training. Real impact.
          </h3>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
            From online phonics classes for young children to keynote sessions
            for educators — every programme is rooted in years of hands-on
            teaching and teacher training.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {photos.map((photo) => (
            <figure
              key={photo.id}
              data-testid={`kalah-action-${photo.id}`}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 bg-slate-100"
            >
              <div className="relative aspect-square">
                <img
                  src={photo.src}
                  alt={photo.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  style={{ objectPosition: photo.objectPosition }}
                />

                {/* Logo-blur overlays */}
                {photo.blurZones.map((zone, idx) => (
                  <div
                    key={idx}
                    aria-hidden="true"
                    className="absolute pointer-events-none"
                    style={{
                      top: zone.top,
                      left: zone.left,
                      width: zone.width,
                      height: zone.height,
                      backdropFilter: 'blur(14px)',
                      WebkitBackdropFilter: 'blur(14px)',
                      backgroundColor: 'rgba(0,0,0,0.08)'
                    }}
                  />
                ))}

                {/* Caption gradient */}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 via-black/35 to-transparent p-4 pt-12">
                  <figcaption className="text-white text-sm sm:text-base font-semibold leading-snug drop-shadow-md">
                    {photo.caption}
                  </figcaption>
                </div>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KalahInAction;
